/*
  Elliot 2026-09-29: "Gör så att allas 'Lägg till i varukorgen' knapp står TILL KASSAN och sen tar
  de direkt till kassan."

  2026-09-30, 00:30: SPLITTESTET AR AVSTANGT. ALLA far "TILL KASSAN". ?ntk_force=cart finns kvar
  for den som uttryckligen vill se det gamla flodet.

  2026-09-30, senare samma dag, tva nya fel Elliot hittade i skarp drift:

  1) "KNAPPEN FUNGERAR INTE NAR JAG GAR TILLBAKA." Reproducerat: klicka Till kassan (knappen blir
     disabled + spinner visas) -> webblasarens EGEN Tillbaka-knapp fran kassasidan. Chrome ateranvander
     da sidan ur BFCACHE (back/forward cache) i stallet for att ladda om den — hela DOM:et, INKLUSIVE
     knappens `disabled`-attribut och spinnerns synlighet, aterstalls till EXAKT det ogonblick sidan
     frostes (mitt i ett pagaende kop). Ingen kod kors om, sa knappen forblir permanent avstangd tills
     kunden manuellt laddar om sidan — vilket ser ut som "knappen fungerar inte", men kunden vet inte
     varfor. Standardlosningen ar `pageshow`-eventet: det eldar BADE vid en vanlig sidladdning OCH vid
     en bfcache-aterstallning, och `event.persisted` skiljer de tva at. Vid persisted=true nollstalls
     varje knapp vi sjalva satt i "laddar"-lage.

  2) "MAN VET INTE OM KLICKET REGISTRERADES." Forsta forsoket riktade sig mot temats egna
     .loader-button__text/.loader-button__loader-spann, men Elliot testade pa den fasta "sticky add
     to cart"-baren langst ner pa sidan — DEN knappen har inte de spannen alls, sa koden hittade
     ingenting och foll tillbaka pa bara en gratonad knapp (opacitet), precis det han klagade pa.
     Losningen nu: knappens HELA innehall sparas undan och ersatts med en egen snurrande ikon
     (samma SVG-cirkel-monster som temats egen spinner pa andra stallen), och det sparade
     innehallet lases tillbaka rakt av vid nollstallning. Funkar identiskt oavsett vilken knapp
     eller markup det ar — text forsvinner helt, en snurra syns i dess stalle.

  BUCKET/split_bucket-korgattributet ligger kvar av samma skal som innan: varje order ska ga att
  koppla till vilket flode kunden sag, och ?ntk_force=cart maste fortfarande fungera for jamforelse.
*/
(function () {
  if (window.__splitTestInit) { return; }
  window.__splitTestInit = true;

  var COOKIE_NAME = 'ntk_split';
  var COOKIE_DAYS = 30;
  var LABEL = 'TILL KASSAN';
  var DEFAULT_BUCKET = 'checkout';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  var forceMatch = location.search.match(/[?&]ntk_force=(checkout|cart)/);
  var bucket;

  if (forceMatch) {
    bucket = forceMatch[1];
    setCookie('ntk_forced', '1', COOKIE_DAYS);
  } else if (getCookie('ntk_forced') === '1' && getCookie(COOKIE_NAME) === 'cart') {
    bucket = 'cart';
  } else {
    bucket = DEFAULT_BUCKET;
  }

  setCookie(COOKIE_NAME, bucket, COOKIE_DAYS);

  document.documentElement.setAttribute('data-split-bucket', bucket);

  function tagCartAttribute() {
    try {
      if (sessionStorage.getItem('ntk_cart_tagged') === bucket) { return; }
    } catch (e) { /* privat lage / blockerad storage - fortsatt anda */ }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { split_bucket: bucket } }),
    }).then(function () {
      try { sessionStorage.setItem('ntk_cart_tagged', bucket); } catch (e) {}
    }).catch(function () {});
  }

  tagCartAttribute();

  if (bucket !== 'checkout') { return; }

  function setButtonLabel(btn) {
    var container = btn.querySelector('.loader-button__text') || btn;
    var textNode = null;

    for (var i = 0; i < container.childNodes.length; i++) {
      var node = container.childNodes[i];
      if (node.nodeType === 3 && node.nodeValue.trim() !== '') {
        textNode = node;
        break;
      }
    }

    if (textNode) {
      textNode.nodeValue = LABEL;
    } else {
      container.appendChild(document.createTextNode(LABEL));
    }

    btn.setAttribute('data-button-content', LABEL);
  }

  var SPLIT_EXEMPT_CLASSES = ['cart-cross-sell__add-button', 'mini-cart-rec__add-button', 'cart-recommendations__add-button'];

  function isExempt(btn) {
    for (var i = 0; i < SPLIT_EXEMPT_CLASSES.length; i++) {
      if (btn.classList.contains(SPLIT_EXEMPT_CLASSES[i])) { return true; }
    }
    return false;
  }

  function applyToButton(btn) {
    if (!btn || btn.dataset.dtcApplied) { return; }
    if (btn.disabled) { return; }
    if (isExempt(btn)) { return; }

    btn.dataset.dtcApplied = '1';
    btn.dataset.directCheckout = 'true';
    setButtonLabel(btn);
  }

  function scan(root) {
    if (!root.querySelectorAll) { return; }

    var buttons = root.querySelectorAll('[data-product-add-to-cart-button]');
    for (var i = 0; i < buttons.length; i++) {
      applyToButton(buttons[i]);
    }

    if (root.matches && root.matches('[data-product-add-to-cart-button]')) {
      applyToButton(root);
    }
  }

  scan(document);

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1) { scan(node); }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Knappar som frostes i "laddar"-lage nar sidan lamnades (klick -> navigering till kassan).
  // Samlas har sa bfcache-aterstallningen nedan kan nollstalla dem igen.
  var inFlightButtons = [];

  // 2026-09-30, andra rundan: Elliot ville ha en RIKTIG snurrande ikon, inte bara en gratonad
  // knapp. Forsoket att aterAnvanda temats egna .loader-button__text/.loader-button__loader-spann
  // visade sig vara ororligt: pa knappen han testade pa (den fasta "sticky add to cart"-baren
  // langst ner) finns inte de spannen alls, sa var kod hittade ingenting och foll tillbaka pa
  // bara opacitet — precis det han klagade pa. Losningen nu ar robust mot VILKEN knapp det an ar:
  // hela knappens innehall sparas undan och ersatts med en egen snurra (samma SVG-monster som
  // temat redan anvander for sin lastik-spinner pa andra stallen, sa den ser hemmahorande ut och
  // roterar med samma @keyframes), och det sparade innehallet lases tillbaka rakt av vid
  // nollstallning — funkar identiskt oavsett om knappen har ikon+text, bara text, eller nagot helt
  // annat inuti.
  var SPINNER_HTML = '<span class="ntk-spinner" aria-hidden="true"><svg viewBox="25 25 50 50" class="ntk-spinner__svg"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></span>';

  // RUNDA 3 (Elliot 2026-09-30, med skarmbild): "cirkeln ar lite hogt upp". Temats knapp ar
  // display:block med line-height: 52px och INGET vertikalt centreringslage — text centreras
  // enbart av radhojden. Var 22px-span la sig da pa TEXTENS BASLINJE, dvs 7 px for hogt (matt:
  // knappmitt -129.9, snurrmitt -136.9). Losningen: las knappens nuvarande hojd (sa den inte
  // krymper nar texten forsvinner) och gor den till en flex-behallare som centrerar i bada
  // led, sa lange laddningen pagar. Inline-stilarna sparas undan och aterstalls rakt av.
  function setLoadingState(btn, loading) {
    if (loading) {
      if (btn.dataset.ntkOriginalHtml === undefined) {
        btn.dataset.ntkOriginalHtml = btn.innerHTML;
        btn.dataset.ntkOriginalStyle = btn.getAttribute('style') || '';
        var h = btn.offsetHeight;
        btn.innerHTML = SPINNER_HTML;
        if (h > 0) { btn.style.height = h + 'px'; }
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
        btn.style.justifyContent = 'center';
        btn.style.lineHeight = 'normal';
        btn.style.opacity = '0.75';
      }
    } else {
      btn.disabled = false;
      if (btn.dataset.ntkOriginalHtml !== undefined) {
        btn.innerHTML = btn.dataset.ntkOriginalHtml;
        if (btn.dataset.ntkOriginalStyle) {
          btn.setAttribute('style', btn.dataset.ntkOriginalStyle);
        } else {
          btn.removeAttribute('style');
        }
        delete btn.dataset.ntkOriginalHtml;
        delete btn.dataset.ntkOriginalStyle;
      }
    }
  }

  // RUNDA 3, del 2 (Elliot: "DIREKT nar man klickar ska den bli lagre i opacity och borja snurra,
  // nu ar det fortfarande en delay"). Snurran sattes forst i submit-hanteraren, och mellan
  // klicket och formularets submit-handelse hinner temats egna klick-lyssnare (loader-button,
  // product-form, Kaching) kora — pa en mobil ar det synligt. Nu gors det VISUELLA redan i
  // klick-handelsen (capture, fore allt annat), UTAN att knappen inaktiveras: en disabled
  // knapp skickar inte formularet, sa disabled satts forst i submit-hanteraren nedan.
  // Vakthund: kommer ingen submit inom 2,5 s (t.ex. formularvalidering stoppade den) aterstalls
  // knappen, annars star kunden med en snurra som aldrig leder nagonstans.
  var awaitingSubmit = null;

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-direct-checkout="true"]') : null;
    if (!btn || btn.disabled) { return; }
    if (btn.dataset.ntkOriginalHtml !== undefined) { return; }

    setLoadingState(btn, true);
    if (awaitingSubmit) { clearTimeout(awaitingSubmit.timer); }
    awaitingSubmit = {
      btn: btn,
      timer: setTimeout(function () {
        if (awaitingSubmit && awaitingSubmit.btn === btn && !btn.disabled) {
          setLoadingState(btn, false);
        }
        awaitingSubmit = null;
      }, 2500),
    };
  }, true);

  // FEL 1 (2026-09-30): bfcache. En knapp frost i disabled+spinner-lage overlever webblasarens
  // Tillbaka-knapp rakt av, eftersom sidan aterstalls ur minnet i stallet for att laddas om — ingen
  // kod kors, sa inget nollstaller den. `pageshow` med `event.persisted === true` ar den enda
  // tillforlitliga signalen for just den har aterstallningen (skiljer den fran en vanlig sidladdning,
  // dar persisted alltid ar false). Nollstaller VARJE knapp vi sjalva satt i "laddar"-lage.
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) { return; }

    for (var i = 0; i < inFlightButtons.length; i++) {
      setLoadingState(inFlightButtons[i], false);
    }
    inFlightButtons = [];
  });

  document.addEventListener('submit', function (event) {
    var btn = event.submitter || event.target.querySelector('[data-direct-checkout="true"]');
    if (!btn || btn.getAttribute('data-direct-checkout') !== 'true') { return; }

    event.stopImmediatePropagation();
    event.preventDefault();

    var form = event.target;
    var formData = new FormData(form);

    if (awaitingSubmit && awaitingSubmit.btn === btn) {
      clearTimeout(awaitingSubmit.timer);
      awaitingSubmit = null;
    }
    setLoadingState(btn, true);
    btn.disabled = true;
    inFlightButtons.push(btn);

    var addRequest = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
    }).then(function (res) {
      if (!res.ok) { throw new Error('cart_add_failed'); }
    });

    var tagRequest = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { split_bucket: bucket } }),
    }).catch(function () { /* taggen ar statistik, aldrig ett skal att stoppa kopet */ });

    Promise.all([addRequest, tagRequest])
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        // Kunde inte lagga i varukorgen (t.ex. slutsald mellan sidladdning och klick). Navigerar
        // ALDRIG till kassan har. Faller tillbaka pa formularets egen /cart/add (icke-JS).
        setLoadingState(btn, false);
        form.submit();
      });
  }, true);
})();
